import FolderIcon from '../Icons/FolderIcon'
import { useState } from 'react'
import { CertificateData } from '../../../constants/ImagesData'
import Thumbnails from '../Icons/Thumbnails'
import useGithubProjects from '../../../hooks/useGithubProjects'
import ContributorAvatars from "../Desktop/ContributorAvatars"
import LanguagesBar from '../Desktop/LanguagesBar'
import readme from "../../assets/icons/readme_icon.png"
import github_icon from "../../assets/icons/github_macos.png"
import ImagePanel from './ImagePanel'
import { AllImages,favourites,works } from '../../../constants/ImagesData'


function innerPanel(data, docClick, isImagePanel) {

    return (
        isImagePanel ? 
        (<div className=' h-full overflow-auto p-4'>
            <div className='grid grid-cols-6 gap-y-6'>
            <div className='bg-red-500 w-10 h-11'/>
            <div className='bg-red-500 w-10 h-11'/>
            <div className='bg-red-500 w-10 h-11'/>
            <div className='bg-red-500 w-10 h-11'/>
        </div> 
        </div>)
        :(<div className="h-full overflow-auto p-4 font-applefont">
            <div className="flex flex-col gap-2">
                <div className='flex gap-3'>
                    <div className='flex flex-col items-center cursor-pointer'>
                        <a href={data.html_url}>
                            <img src={github_icon} className='w-20' alt="" />
                        </a>
                        <h1 className='text-[11px] text-black/60'>
                            github
                        </h1>
                    </div>
                    <div
                        onClick={() => docClick({ 'owner': data.owner?.login, 'name': data.name })}
                        className='flex flex-col items-center cursor-pointer'>
                        <img src={readme} className='w-20' alt="" />
                        <h1 className='text-[11px] text-black/60'>
                            readme.md
                        </h1>
                    </div>

                </div>
                <div>
                    <p className="text-[13px] py-1 text-black-main/50 mr-1 whitespace-nowrap">
                        Description
                    </p>
                    <h1 className='text-[14px] text-black-main'>
                        {data.description}
                    </h1>
                </div>
                <div>
                    <p className="text-[13px] text-black-main/50 mr-1 whitespace-nowrap">
                        Languages
                    </p>
                    <LanguagesBar owner={data.owner?.login} repo={data.name} />
                </div>
                <div>
                    <p className="text-[13px] text-black-main/50 mr-1 whitespace-nowrap">
                        Contributers
                    </p>
                    <ContributorAvatars owner={data.owner?.login} repo={data.name} />

                    {/* <div className='flex gap-2 mt-1 w-9'>
                        {
                            data.tools.map((tool) =>
                                <img src={projectIcons[tool]} alt={tool} />
                            )
                        }
                    </div> */}
                </div>
            </div>
        </div>)
    );
}



export default function Panel({
    panelType,
    imageClick,
    docClick,
    setTitle,
    setIsSubPanelOpen,
    isSubPanelOpen,
    isImagePanel,
    setIsImagePanel,
    setSelectedProject,
    selectedProject
}) {

    const [source , setSource] = useState(null);

    const { projects } = useGithubProjects("badu01");

    // ----------------------------------------
    // IMAGE SUB PANEL
    // ----------------------------------------

    if (isImagePanel && isSubPanelOpen) {
        return (
            <ImagePanel imgSrc={source} path={selectedProject} onClick={imageClick}/>
        );
    }

    // ----------------------------------------
    // PROJECT SUB PANEL
    // ----------------------------------------

    if (selectedProject && isSubPanelOpen) {
        return innerPanel(
            selectedProject,
            docClick,
            false
        );
    }

    // ----------------------------------------
    // MAIN PANEL
    // ----------------------------------------

    return (
        <div className="h-full overflow-auto p-4">

            <div className="grid grid-cols-6 gap-y-6 gap-x-4">

                {/* ================= PROJECTS ================= */}

                {panelType === "All projects" && (
                    <>
                        {projects.map((project) => (
                            <FolderIcon
                                key={project.name}
                                name={project.name}
                                onClick={() => {
                                    setTitle(project.name);
                                    setSelectedProject(project);
                                    setIsImagePanel(false);
                                    setIsSubPanelOpen(true);
                                }}
                                isDraggable={false}
                            />
                        ))}
                    </>
                )}

                {/* ================= CERTIFICATES ================= */}

                {panelType === "certificates" && (
                    <>
                        {CertificateData.map((certificate) => (
                            <Thumbnails
                                key={certificate.title}
                                imgSource={certificate.src}
                                name={certificate.title}
                                onClick={imageClick}
                            />
                        ))}
                    </>
                )}

                {/* ================= PHOTOS ================= */}

                {panelType === "photos" && (
                    <>
                        <FolderIcon
                            name="imgs"
                            onClick={() => {
                                setTitle("imgs");
                                setSelectedProject("/imgs");
                                setSource(AllImages)
                                setIsImagePanel(true);
                                setIsSubPanelOpen(true);
                            }}
                            isDraggable={false}
                        />

                        <FolderIcon
                            name="favourites"
                            onClick={() => {
                                setTitle("favourites");
                                setSelectedProject("/favourites");
                                setSource(favourites)
                                setIsImagePanel(true);
                                setIsSubPanelOpen(true);
                            }}
                            isDraggable={false}
                        />

                        <FolderIcon
                            name="designs"
                            onClick={() => {
                                setTitle("designs");
                                setSelectedProject("/designs");
                                setSource(works)
                                setIsImagePanel(true);
                                setIsSubPanelOpen(true);
                            }}
                            isDraggable={false}
                        />

                        {/* <FolderIcon
                            name="photography"
                            onClick={() => {
                                setTitle("photography");
                                setSelectedProject("/photography");
                                setIsImagePanel(true);
                                setIsSubPanelOpen(true);
                            }}
                            isDraggable={false}
                        /> */}
                    </>
                )}

            </div>
        </div>
    );
}
